<!--
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2022-01-24 15:35:41
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\layout.vue
-->
<template>
  <div class="app_div">
    <top />
    <header-info  :queryParams="queryParams"/>
    <router-view :key="$route.query.t ? $route.query.t : ''" :queryParams="queryParams"/>
    <footer-info/>
    <right-aside :queryParams="queryParams"/>
  </div>
</template>

<script>
import HeaderInfo from '@/components/pageComponents/header.vue';
import top from '@/components/pageComponents/top.vue';
import FooterInfo from '@/components/pageComponents/footer.vue'
import $ from 'jquery'
import RightAside from '../components/pageComponents/rightAside.vue';
export default {
  components: { top,FooterInfo ,HeaderInfo,RightAside},
  data() {
    return {
      queryParams:{searchKey:null,fromPage:null,isShowNewProduct:true,}
    };
  },
  mounted(){
    this.fixedFooter()
  },
  methods: {
    fixedFooter(){
      $(function(){
          function footerPosition(){
              $("footer_area").removeClass("fixed-bottom");
              var contentHeight = document.body.scrollHeight,//网页正文全文高度
                  winHeight = window.innerHeight;//可视窗口高度，不包括浏览器顶部工具栏
              if(!(contentHeight > winHeight)){
                  //当网页正文高度小于可视窗口高度时，为footer添加类fixed-bottom
                  $("footer_area").addClass("fixed-bottom");
              } else {
                  $("footer_area").removeClass("fixed-bottom");
              }
          }
          footerPosition();
          $(window).resize(footerPosition);
      });
    }
  }
};
</script>
<style>
.app_div{
  width: 100%;
  height: 100vh;
  text-align: center;
}
/* 动态为footer添加类fixed-bottom */
.fixed-bottom {position: fixed;bottom: 0;width:100%;}
</style>


// WEBPACK FOOTER //
// src/views/layout.vue